import { render, staticRenderFns } from "./amendTicket.vue?vue&type=template&id=04b087dc"
import script from "./amendTicket.vue?vue&type=script&lang=js"
export * from "./amendTicket.vue?vue&type=script&lang=js"
import style0 from "./amendTicket.vue?vue&type=style&index=0&id=04b087dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports